import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './wallet-content.magic.css.js';
import script from './wallet-content.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cashier page",attrs:{"data-v-test-id":"cashier-page"}},[_c('magic-galleon',{ref:"wallet",on:{"load":_vm.onLoad,"log-message":_vm.onLogMessage,"change-view":_vm.onViewChange,"deposit-result":_vm.onDepositResult,"withdraw-result":_vm.onWithdrawResult,"deposit-completed":_vm.goToGames,"open-tnc":_vm.openTnc,"withdraw-completed":_vm.goToGames,"cashier-pending-withdrawals":_vm.onWithdrawals}},[(_vm.hasCustomContent('header'))?_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),(_vm.showProtectedFunds)?_c('div',{attrs:{"slot":"cashier-content"},slot:"cashier-content"},[_c('div',{staticClass:"compliance"},[_c('magic-ui-icon',{staticClass:"compliance__icon",attrs:{"name":"compliance","part":"compliance__icon"}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"compliance__title",attrs:{"tag":"b","part":"compliance__title","content":_vm.$t('deposit.compliance.title')}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"compliance__content",attrs:{"tag":"p","part":"compliance__content","is-markdown":"true","content":_vm.$t('deposit.compliance.description')}}),_vm._v(" "),_c('magic-ui-button',{staticClass:"compliance__approve-btn",attrs:{"variant":"primary","wide":"true","disabled":_vm.isSubmittingCompliance},on:{"click":_vm.agreeClickHandler}},[_vm._v("\n                    "+_vm._s(_vm.$t('deposit.compliance-agree.button'))+"\n                ")])],1)]):_vm._e(),_vm._v(" "),(_vm.hasCustomContent('deposit-success'))?_c('div',{attrs:{"slot":"deposit-success"},slot:"deposit-success"},[_vm._t("deposit-success")],2):_vm._e(),_vm._v(" "),(_vm.hasCustomContent('deposit-pending-success'))?_c('div',{attrs:{"slot":"deposit-pending-success"},slot:"deposit-pending-success"},[_vm._t("deposit-pending-success")],2):_vm._e(),_vm._v(" "),(_vm.hasCustomContent('withdraw-success'))?_c('div',{attrs:{"slot":"withdraw-success"},slot:"withdraw-success"},[_vm._t("withdraw-success")],2):_vm._e()])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-66cbdbf8_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-66cbdbf8";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
